export const initObfuscatedContactLinks = (): void => {
  const placeholders = document.querySelectorAll<HTMLElement>(
    ".hwk-obfuscated-contact",
  );

  placeholders.forEach((placeholder) => {
    if (placeholder.tagName.toLowerCase() !== "span") {
      return;
    }

    const contactType = placeholder.dataset.contactType;

    if (!contactType) {
      return;
    }

    try {
      const link = document.createElement("a");

      for (const attr of Array.from(placeholder.attributes)) {
        const { name, value } = attr;
        link.setAttribute(name, value);
      }

      if (contactType === "mailto") {
        const localRaw = placeholder.dataset.local;
        const domainRaw = placeholder.dataset.domain;
        const contactQuery = placeholder.dataset.contactQuery ?? "";
        const labelRaw = placeholder.dataset.label ?? "";

        if (!localRaw || !domainRaw) {
          return;
        }

        const localParts = JSON.parse(localRaw) as string[];
        const domainParts = JSON.parse(domainRaw) as string[];
        const labelParts = labelRaw ? JSON.parse(labelRaw) : [];

        if (!Array.isArray(localParts) || !Array.isArray(domainParts)) {
          return;
        }

        const email = `${localParts.join("")}@${domainParts.join("")}`;
        link.href = contactQuery
          ? `mailto:${email}?${contactQuery}`
          : `mailto:${email}`;

        const label = labelParts.join("");

        link.textContent = label || email;
        link.removeAttribute("data-local");
        link.removeAttribute("data-domain");
        link.removeAttribute("data-contact-query");
      } else if (contactType === "tel") {
        const phoneRaw = placeholder.dataset.phone;

        if (!phoneRaw) {
          return;
        }

        const phoneParts = JSON.parse(phoneRaw) as string[];

        if (!Array.isArray(phoneParts)) {
          return;
        }

        const phone = phoneParts.join("");
        link.href = `tel:${phone}`;

        link.textContent = phone;
        link.removeAttribute("data-phone");
      } else {
        return;
      }

      link.removeAttribute("data-contact-type");

      placeholder.replaceWith(link);
    } catch (error) {
      console.error("Kontakt-Link konnte nicht aufgebaut werden:", error);
    }
  });
};
